const sky = {
  100: "#F1FAFE",
  200: "#E7F6FE",
  300: "#CDEEFE",
  400: "#87D5FD",
  500: "#4FBFF8",
  600: "#2CA2DD",
  700: "#248ABC",
  800: "#1C6692",
  900: "#114669",
  contrastDefaultColor: "#ffffff"
}

export default sky
